import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { applyEventsSearchCriteria, clearEventsSearchCriteria } from "domains/events/actions";
import { getEventsSearchCriteria } from "domains/events/selectors";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicEventFilterModal = () => {
  const dispatch = useDispatch();
  const searchCriteria = useSelector(getEventsSearchCriteria);
  const translate = useTranslate();
  const filters = useSelector(getTopicFilters("events"));

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyEventsSearchCriteria(payload))}
      handleClear={() => dispatch(clearEventsSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.events.filter.title")}
    />
  );
};
